import React from 'react';
import { Icon } from '@iconify/react';

const PlanDetailCard = ({ plan, onSelect, isSelected, showSelectButton = false }) => {
    if (!plan) return null;

    const isPopular = plan.name === 'Premium' || plan.isPopular;

    return (
        <div className={`card h-100 border-0 shadow-sm radius-16 transition-all position-relative overflow-hidden ${isSelected ? 'ring-2 ring-primary-main bg-primary-50' : 'bg-white hover-shadow-md'}`}>
            {isPopular && (
                <div className="position-absolute top-0 end-0 bg-warning-main text-white text-xs fw-bold px-24 py-4 radius-bl-12 z-1">
                    Most Popular
                </div>
            )}

            <div className="card-body p-24 d-flex flex-column h-100">
                <div className="mb-20 d-flex align-items-center gap-3">
                    <div className={`w-48-px h-48-px radius-12 d-flex justify-content-center align-items-center text-xl ${isSelected ? 'bg-primary-main text-white' : 'bg-primary-50 text-primary-600'}`}>
                        <Icon icon={(plan.name?.toLowerCase() === 'enterprise' || plan.name?.toLowerCase() === 'premium') ? 'solar:crown-star-bold' : 'solar:box-bold'} />
                    </div>
                    <div>
                        <h5 className="mb-0 fw-bold text-primary-dark">{plan.name}</h5>
                        <div className="d-flex align-items-baseline gap-1">
                            <h4 className="mb-0 fw-bolder text-dark">
                                {plan.currency === 'INR' ? '₹' : '$'}{plan.price}
                            </h4>
                            <span className="text-secondary text-sm">/{plan.duration === '365' ? 'yr' : 'mo'}</span>
                        </div>
                    </div>
                </div>

                <div className="mb-24 flex-grow-1">
                    <p className="text-secondary text-sm mb-16 line-clamp-2">{plan.description || "Perfect for growing clinics."}</p>

                    <ul className="d-flex flex-column gap-3">
                        <li className="d-flex align-items-center gap-2 text-sm text-primary-dark">
                            <Icon icon="solar:user-bold-duotone" className="text-primary-main text-lg" />
                            <span className="fw-medium">{plan.limits?.maxDoctors === 0 ? 'Unlimited' : plan.limits?.maxDoctors} Doctors</span>
                        </li>
                        <li className="d-flex align-items-center gap-2 text-sm text-primary-dark">
                            <Icon icon="solar:users-group-rounded-bold-duotone" className="text-primary-main text-lg" />
                            <span className="fw-medium">{plan.limits?.maxStaff === 0 ? 'Unlimited' : plan.limits?.maxStaff} Staff Members</span>
                        </li>
                        <li className="d-flex align-items-center gap-2 text-sm text-primary-dark">
                            <Icon icon="solar:database-bold-duotone" className="text-primary-main text-lg" />
                            <span className="fw-medium">{plan.limits?.storageGB}GB Storage</span>
                        </li>

                        <div className="my-2 border-top border-neutral-200"></div>

                        {(plan.features || []).map((feature, idx) => (
                            <li key={idx} className="d-flex align-items-center gap-2 text-sm text-secondary">
                                <Icon icon="solar:check-circle-bold" className="text-success-main text-lg flex-shrink-0" />
                                <span>{feature}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                {showSelectButton && (
                    <button
                        type="button"
                        onClick={() => onSelect(plan._id)}
                        className={`btn w-100 py-12 radius-8 fw-semibold d-flex align-items-center justify-content-center gap-2 ${isSelected ? 'btn-primary' : 'btn-outline-primary'}`}
                    >
                        {isSelected ? (
                            <>
                                <Icon icon="solar:check-circle-bold" className="text-lg" />
                                Selected
                            </>
                        ) : (
                            'Select Plan'
                        )}
                    </button>
                )}
            </div>
        </div>
    );
};

export default PlanDetailCard;
